import { registeredTabsHandlers } from '@/global/components/view-layouts/tabs-layout/common/registered-tabs-handlers'
import { registeredTableHandlers } from '@/global/components/view-layouts/tabs-layout/config/registered-table-handlers'
import { isObject, cloneDeep } from '@/global/utils/utils'
import { dateService, FORMATS } from '@/global/services/date'
import { api } from '@/global/services/api'

export default {
  methods: {
    showDocumentEdit (event) {
      const { setFormData } = registeredTabsHandlers?.documents || {}
      const { data } = event || {}
      const clonedData = cloneDeep(data)
      const { showDetails, setDetailsTitle } = this.blockConfig || {}
      const appendToDetailsTitle = clonedData?.name || this.$t('fleet/vehicle.details')
      const detailsTitle = this.$t('fleet/vehicle.document') + ' - ' + appendToDetailsTitle

      if (typeof setFormData === 'function' && data && isObject(data)) {
        // convert dates for correct display
        clonedData.issued = clonedData?.issued ? dateService.formatCustom(data.issued, FORMATS.isoDate, FORMATS.date) : null
        clonedData.valid_until = clonedData?.issued ? dateService.formatCustom(data.valid_until, FORMATS.isoDate, FORMATS.date) : null

        // update details title
        setDetailsTitle?.(detailsTitle)
        this.documentDetailsTitle = detailsTitle
        // set form data
        setFormData(clonedData)
      }

      // show details
      showDetails?.()
      this.showDocumentsTable = false
      this.showDocumentDetails = true
    },

    onDocumentActivation (event) {
      const { status, id, name } = event?.data || {}
      if (!id) {
        return
      }
      const title = status ? this.$t('fleet/vehicle.document_deactivation_title') : this.$t('fleet/vehicle.document_activation_title')
      this.$set(this.informationDialogConfig, 'title', title + ' - ' + (name || '/'))
      this.$set(this.informationDialogConfig, 'message', status ? this.$t('fleet/vehicle.document_deactivation_message') : this.$t('fleet/vehicle.document_activation_message'))
      this.$set(this.informationDialogConfig, 'callbackFn', () => this.documentActivationCallback(event))
      this.$set(this.informationDialogConfig, 'openDialog', true)
    },

    async documentActivationCallback (event) {
      try {
        const { id, status } = event?.data || {}
        const { fetchData } = registeredTableHandlers?.documents || {}
        const formData = new FormData()
        formData.append('_method', 'PATCH')
        formData.append('status', status ? 'false' : 'true')

        await api('fleet').post(`vehicle-document-status/${id}`, formData)

        this.$set(this.informationDialogConfig, 'openDialog', false)
        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        console.error(exception)
      }
    },

    onDocumentSendEmail (event) {
      const { id } = event?.data || {}
      if (id) {
        this.documentEmailId = id
        this.$set(this.sendDocumentOnEmailDialogConfig, 'openDialog', true)
      }
    },

    async sendEmail () {
      try {
        if (!this.documentEmailId) {
          return
        }

        if (!this.documentEmailFormData.email) {
          this.$set(this.documentEmailValidationErrors, 'email', this.$t('fleet/vehicle.document_email_missing'))
          return
        }
        else if (!this.documentEmailFormData.message) {
          this.$set(this.documentEmailValidationErrors, 'message', this.$t('fleet/vehicle.document_message_missing'))
          return
        }

        const formData = new FormData()
        formData.append('_method', 'PATCH')
        formData.append('email', this.documentEmailFormData.email)
        formData.append('message', this.documentEmailFormData.message)

        await api('fleet').post(`vehicle-document-send-to-email/${this.documentEmailId}`, formData)
        this.$set(this.sendDocumentOnEmailDialogConfig, 'openDialog', false)
        this.documentEmailId = null
      }
      catch (exception) {
        console.error(exception)
      }
    },

    async removeImageCallback (event) {
      try {
        const { module, route } = event?.removeApiConfig || {}
        const { uuid: imageUuid, tabKey } = event?.file || {}
        const { index } = event || {}
        const { fetchData } = registeredTableHandlers?.[tabKey] || {}

        if (module && route && imageUuid) {
          await api(module).delete(route + imageUuid)
          this.imagesPreviewDialogConfig.images = this.imagesPreviewDialogConfig.images.filter((_, i) => i !== index)
          if (typeof fetchData === 'function') {
            fetchData()
          }
        }
      }
      catch (exception) {
        console.error(exception)
      }
    },

    onDocumentEmailDataUpdate (data) {
      this.documentEmailFormData = cloneDeep(data)
    },

    onDocumentDeletion (event) {
      const { id, name } = event?.data || {}
      if (!id) {
        return
      }

      const maxNameLength = 30
      const nameTitle = name && typeof name === 'string' && name.length > maxNameLength ? name.slice(0, maxNameLength) + '...' : name
      this.$set(this.informationDialogConfig, 'title', this.$t('fleet/vehicle.document_deletion_title') + (nameTitle ? ' - ' + nameTitle : ''))
      this.$set(this.informationDialogConfig, 'message', this.$t('fleet/vehicle.document_deletion_message'))
      this.$set(this.informationDialogConfig, 'positiveBtnText', this.$t('base.confirm'))
      this.$set(this.informationDialogConfig, 'callbackFn', () => this.documentDelete(event))
      this.$set(this.informationDialogConfig, 'openDialog', true)
    },

    async documentDelete (event) {
      try {
        const { id } = event?.data || {}
        const { fetchData } = registeredTableHandlers?.documents || {}

        await api('fleet').delete(`vehicle-document/${id}`)

        this.$set(this.informationDialogConfig, 'openDialog', false)
        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        console.error(exception)
      }
    }
  }
}
